module.exports = __webpack_public_path__ + "static/lake_erosion_wide-64983741b948818f9d020fa281e4c583.jpg";